import { isEmpty } from 'lodash';

const TOKEN_KEY = 'jwtToken';
const USER_INFO = 'userInfo';

const parse = JSON.parse;
const stringify = JSON.stringify;

const authUtils = {
  /**
   * Remove an item from the used storage
   * @param  {String} key [description]
   */
  clear(key: string) {
    if (localStorage && localStorage.getItem(key)) {
      return localStorage.removeItem(key);
    }

    if (sessionStorage && sessionStorage.getItem(key)) {
      return sessionStorage.removeItem(key);
    }

    return null;
  },

  /**
   * Clear all app storage
   */
  clearAppStorage() {
    if (localStorage) {
      localStorage.clear();
    }

    if (sessionStorage) {
      sessionStorage.clear();
    }
  },

  clearToken(tokenKey = TOKEN_KEY) {
    return authUtils.clear(tokenKey);
  },

  clearUserInfo(userInfo = USER_INFO) {
    return authUtils.clear(userInfo);
  },

  /**
   * Returns data from storage
   * @param  {String} key Item to get from the storage
   * @return {String|Object}     Data from the storage
   */
  get(key: string) {
    if (localStorage && window.localStorage.getItem(key)) {
      return parse(window.localStorage.getItem(key)) || null;
    }

    if (sessionStorage && window.sessionStorage.getItem(key)) {
      return parse(window.sessionStorage.getItem(key)) || null;
    }

    return null;
  },

  getToken(tokenKey = TOKEN_KEY) {
    return authUtils.get(tokenKey);
  },

  getUserInfo(userInfo = USER_INFO) {
    return authUtils.get(userInfo);
  },

  /**
   * Set data in storage
   * @param {String|Object}  value    The data to store
   * @param {String}  key
   * @param {Boolean} isLocalStorage  Defines if we need to store in localStorage or sessionStorage
   */
  set(value: string, key: string, isLocalStorage = true) {
    if (isEmpty(value)) {
      return null;
    }

    if (isLocalStorage && window.localStorage) {
      return window.localStorage.setItem(key, stringify(value));
    }

    if (window.sessionStorage) {
      return window.sessionStorage.setItem(key, stringify(value));
    }

    return null;
  },

  setToken(value = '', isLocalStorage = false, tokenKey = TOKEN_KEY) {
    return authUtils.set(value, tokenKey, isLocalStorage);
  },

  setUserInfo(value = '', isLocalStorage = false, userInfo = USER_INFO) {
    return authUtils.set(value, userInfo, isLocalStorage);
  },
};

export default authUtils;
